/* KODDID · Carrito enriquecido Bluet B
   - Contador "Carrito reservado" (10 min, persistente en la sesión)
   - Línea de tiempo con fechas reales de envío/entrega
   Funciona aunque el drawer se vuelva a renderizar (Section Rendering API):
   usa un intervalo global que refresca cualquier nodo presente en el DOM. */
(function () {
  'use strict';

  var CUTOFF_HOUR = 15; // hora límite para que "salga hoy"
  var RESERVE_MS = 10 * 60 * 1000; // 10 minutos
  var WD = ['dom', 'lun', 'mar', 'mié', 'jue', 'vie', 'sáb'];

  function isWeekday(d) {
    var w = d.getDay();
    return w !== 0 && w !== 6;
  }

  function nextBusinessDay(date) {
    var d = new Date(date);
    do {
      d.setDate(d.getDate() + 1);
    } while (!isWeekday(d));
    return d;
  }

  function addBusinessDays(date, n) {
    var d = new Date(date);
    var added = 0;
    while (added < n) {
      d.setDate(d.getDate() + 1);
      if (isWeekday(d)) added++;
    }
    return d;
  }

  function two(n) {
    return (n < 10 ? '0' : '') + n;
  }

  // ---- Contador "carrito reservado" ----
  function reserveRemaining() {
    var now = Date.now();
    var dl = parseInt(sessionStorage.getItem('bluetb_cart_deadline') || '0', 10);
    if (!dl || now >= dl) {
      dl = now + RESERVE_MS;
      try { sessionStorage.setItem('bluetb_cart_deadline', String(dl)); } catch (e) {}
    }
    return Math.max(0, dl - now);
  }

  // ---- Línea de tiempo de entrega ----
  function deliveryInfo() {
    var now = new Date();
    var orderedToday = isWeekday(now) && now.getHours() < CUTOFF_HOUR;
    var dispatch = orderedToday ? now : nextBusinessDay(now);
    var d1 = addBusinessDays(dispatch, 1);
    var d2 = addBusinessDays(dispatch, 2);

    var cutoffTxt = '';
    if (orderedToday) {
      var cut = new Date(now);
      cut.setHours(CUTOFF_HOUR, 0, 0, 0);
      var ms = cut - now;
      var h = Math.floor(ms / 3600000);
      var m = Math.floor((ms % 3600000) / 60000);
      cutoffTxt = (h > 0 ? h + ' h ' : '') + m + ' min';
    }

    return {
      dispatchLabel: orderedToday ? 'hoy' : WD[dispatch.getDay()] + ' ' + dispatch.getDate(),
      deliveryLabel: WD[d1.getDay()] + ' ' + d1.getDate() + ' – ' + WD[d2.getDay()] + ' ' + d2.getDate(),
      cutoffTxt: cutoffTxt,
      orderedToday: orderedToday
    };
  }

  function tick() {
    // Contadores
    var ms = reserveRemaining();
    var mm = Math.floor(ms / 60000);
    var ss = Math.floor((ms % 60000) / 1000);
    var cTxt = mm + ':' + two(ss);
    var cnodes = document.querySelectorAll('[data-k-countdown]');
    for (var i = 0; i < cnodes.length; i++) cnodes[i].textContent = cTxt;

    // Fechas de entrega (solo si hay algún nodo)
    var dnodes = document.querySelectorAll('[data-k-date],[data-k-cutoff],[data-k-cutoff-wrap]');
    if (dnodes.length) {
      var info = deliveryInfo();
      var s;
      for (var j = 0; j < dnodes.length; j++) {
        s = dnodes[j];
        if (s.hasAttribute('data-k-date')) {
          s.textContent = s.getAttribute('data-k-date') === 'delivery' ? info.deliveryLabel : info.dispatchLabel;
        } else if (s.hasAttribute('data-k-cutoff')) {
          s.textContent = info.cutoffTxt;
        } else if (s.hasAttribute('data-k-cutoff-wrap')) {
          s.style.display = info.orderedToday ? '' : 'none';
        }
      }
    }
  }

  // ---- Abrir el carrito como desplegable (drawer) desde la cabecera ----
  function openDrawer(e) {
    var trigger = e.target.closest('[data-k-cart-trigger]');
    if (!trigger) return;
    var drawer = document.getElementById('cart-drawer');
    if (!drawer || typeof drawer.open !== 'function') return; // sin drawer → deja navegar a /cart
    // No interceptar clic con modificador (abrir en pestaña nueva) ni botón central
    if (e.metaKey || e.ctrlKey || e.shiftKey || e.button === 1) return;
    e.preventDefault();
    drawer.open();
  }

  // ---- Sincronizar el contador del carrito del header ante cualquier cambio ----
  function syncBadge() {
    fetch('/cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var els = document.querySelectorAll('.k-head__cart-count');
        for (var i = 0; i < els.length; i++) {
          els[i].textContent = cart.item_count;
          if (cart.item_count > 0) { els[i].removeAttribute('hidden'); }
          else { els[i].setAttribute('hidden', ''); }
        }
      })
      .catch(function () {});
  }

  function patchFetch() {
    if (!window.fetch || window.__kCartFetchPatched) return;
    window.__kCartFetchPatched = true;
    var orig = window.fetch;
    window.fetch = function () {
      var url = '';
      try { var a = arguments[0]; url = (typeof a === 'string') ? a : (a && a.url) || ''; } catch (e) {}
      var p = orig.apply(this, arguments);
      if (/\/cart\/(add|change|update|clear)(\.js)?/.test(url)) {
        p.then(function () { setTimeout(syncBadge, 120); }).catch(function () {});
      }
      return p;
    };
  }

  function start() {
    tick();
    setInterval(tick, 1000);
    document.addEventListener('click', openDrawer);
    patchFetch();
    syncBadge();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
